import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import DragAndDrop from '../Common/dragAndDrop'
import CropperModal from '../CropperModal'

import './rubros.css'

class RubroEdit extends React.Component {

    render() {
        return (
            <div className='crearEditarRubro'>

                {/* menú superior */}
                <TitleBar
                    title={((this.props.rubro.idRubro === 0) ? 'Nuevo ' : 'Editar ') + this.props.entidad}
                    handleOnSave={this.props.handleOnSave}
                    handleOnBack={this.props.handleOnCancel}
                    showSearch={false}
                />

                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={12}>
                            <TextField className='myInput'
                                label='Nombre'
                                name='nombre'
                                fullWidth
                                required
                                value={this.props.rubro.nombre}
                                onChange={this.props.handleOnChange}

                                error={this.props.error && this.props.error.nombre}
                                helperText={(this.props.error && this.props.error.nombre) ? this.props.error.nombre : ""}

                                style={{ margin: "10px", width: "98%", }}
                            />
                        </Col>

                    </Row>
                </Paper>

                <DragAndDrop
                    accept='image/jpeg, image/png'
                    message='Arrastra la imagen o'
                    handleOnDrop={this.props.handleOnDropFile}
                    multiple={false}
                />

                {
                    this.props.rubro.imagen &&
                    <div className='imageContainer'>
                        <div>
                            <img onClick={() => { this.props.handleOnOpenCropperModal() }}
                                src={this.props.rubro.imagen}
                                style={{ width: "200px", height: "300px" }}
                                alt={""}></img>
                        </div></div>
                }


                <div style={{ paddingBottom: "60px" }}></div>


                {this.props.openModalImagen &&
                    <CropperModal
                        ratio={2 / 3}
                        src={this.props.imagenOriginal}
                        handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
                        handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
                        open={this.props.openModalImagen}
                        modalArticulo={true /* imagen vertical */}
                    />
                }
            </div>
        )
    }
}

RubroEdit.propTypes = {
    rubro: PropTypes.object.isRequired,
    error: PropTypes.object,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired
}

RubroEdit.defaultProps = {
    catalogos: []
}

export default RubroEdit